import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import Notiflix from "notiflix";

// ANT DESIGN IMPORTS
import {
  ConfigProvider,
  Input,
  Row,
  Typography,
  DatePicker,
  Col,
  Card,
  Table,
  InputNumber,
  Form,
  Spin,
  Select,
  Button,
  Statistic,
  Divider,
} from "antd";
import { ReloadOutlined } from "@ant-design/icons";

// PROJECT IMPORTS
import { CSVLink } from "react-csv";
import MainLayout from "../../../../components/layouts/MainLayout";
import TopContent from "../../../../components/layouts/TopContent";
import { BOM } from "../../../../services/definedMethod";
import cnt from "../../../../services/definedConstant";
import DownloadTableButtons from "../../../../components/DownloadTableButtons";
import { labelConfig, staticConfig, apiConfig } from "../../operations.config";
import { rightAction } from "../../../../redux/actions";
import styles from "../../../../assets/styles/styles";
import CustomButton from "../../../../components/custom/CustomButton";

const rowSelection = {
  onChange: (selectedRowKeys, selectedRows) => {},
  getCheckboxProps: (record) => ({
    disabled: record.name === "Disabled User",
    name: record.name,
  }),
};
const columns = [
  {
    title: labelConfig.id,
    dataIndex: "id",
  },
  {
    title: labelConfig.madeOnDate,
    dataIndex: "madeOnDate",
  },
  {
    title: labelConfig.user,
    dataIndex: "user",
  },
  {
    title: labelConfig.action,
    dataIndex: "action",
  },
  {
    title: labelConfig.entity,
    dataIndex: "entity",
  },
  {
    title: labelConfig.status,
    dataIndex: "status",
  },
];

const SearchCheckerInbox = (props) => {
  const { userData, rightBtn, rightAction } = props;

  const { session } = userData;
  const { Text, Title } = Typography;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [useForm] = Form.useForm();
  const [isLoading, setIsLoading] = useState(true);
  const [selectedRows, setSelectedRows] = useState(null);
  const [selectedRowsKeys, setSelectedRowsKeys] = useState([]);
  const [tableCount, setTableCount] = useState("10");
  const [checkerInboxList, setCheckerInboxList] = useState([]);
  const [originalList, setOriginalList] = useState([]);
  const [entityData, setEntityData] = useState([]);
  const [actionData, setActionData] = useState([]);
  const [showSearch, setShowSearch] = useState(false);

  useEffect(() => {
    getSearchTemplate();
  }, []);

  function getSearchTemplate() {
    const url = `${apiConfig.MakerCheckers}/searchtemplate`;
    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        const objList = res;

        let tempUsersData = [];
        let tempActionData = [];
        let tempEntityData = [];
        let tempStatusData = [];

        objList?.appUsers?.forEach((element) => {
          tempUsersData.push({
            value: element.id,
            label: element.username,
          });
        });

        objList?.actionNames?.forEach((element, index) => {
          tempActionData.push({
            value: index,
            label: element,
          });
        });

        objList?.entityNames?.forEach((element, index) => {
          tempEntityData.push({
            value: index,
            label: element,
          });
        });

        objList?.processingResults?.forEach((element) => {
          tempStatusData.push({
            value: element.id,
            label: element.processingResult,
          });
        });

        setActionData(tempActionData);
        setEntityData(tempEntityData);

        dispatch({ type: cnt.CLEAR_RIGHT_BTN });
      }
    });

    setIsLoading(false);
  }

  // FLOAT METHODS
  function handleOnView() {
    const { detailBtn } = rightBtn;
    if (detailBtn.toLowerCase() === "primary") {
      navigate("/detail-checker-inbox", {
        state: { id: selectedRows[0].id },
      });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  const handleOnDelete = () => {
    let action = "Delete  ";
    let checkerName = selectedRows.length === 1 ? "Action " : "Actions ";

    Notiflix.Confirm.show(
      "Are you sure?",
      action + checkerName,
      "Yes",
      "No",

      function () {
        setIsLoading(true);
        const params = { command: "delete" };

        try {
          if (selectedRows.length === 1) {
            // Single row submission
            let body = {
              method: "DELETE",
              session,
              params,
            };

            const url = `${apiConfig.MakerCheckers}/${selectedRows[0].id}`;

            BOM.FetchReqAction(body, url, (err, res) => {
              if (err) {
                BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
                getSearchTemplate();
                //STOP LOAD
                setIsLoading(false);
              } else {
                BOM.AlertMsg(cnt.SUCCESS, labelConfig.deleteCheckerMsg);
                getSearchTemplate();
                //STOP LOAD
                setIsLoading(false);
              }
            });
          } else {
            // Batch submission (2 or more rows)
            selectedRows.map((row) => {
              let body = {
                method: "DELETE",
                session,
                params,
              };

              const url = `${apiConfig.MakerCheckers}/${row.id}`;

              return BOM.FetchReqAction(body, url, (err, res) => {
                if (err) {
                  BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
                  getSearchTemplate();
                  //STOP LOAD
                  setIsLoading(false);
                } else {
                  BOM.AlertMsg(cnt.SUCCESS, labelConfig.deleteCheckerMsg);
                  // getSearchTemplate()
                  setTimeout(() => {
                    setSelectedRowsKeys([]);
                  }, 1000);
                  //STOP LOAD
                  setIsLoading(false);
                }
              });
            });
          }
        } catch (error) {
          console.error(error);
        }
      }
    );
  };

  function handleOnApprove() {
    let action = "Approve  ";
    let checkerName = selectedRows.length === 1 ? "Action " : "Actions ";
    setSelectedRowsKeys([]);

    Notiflix.Confirm.show(
      "Are you sure?",
      action + checkerName,
      "Yes",
      "No",

      function () {
        setIsLoading(true);
        const params = { command: "approve" };

        try {
          if (selectedRows.length === 1) {
            // Single row submission
            let body = {
              method: "POST",
              session,
              params,
            };

            const url = `${apiConfig.MakerCheckers}/${selectedRows[0].id}`;

            BOM.FetchReqAction(body, url, (err, res) => {
              if (err) {
                BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
                getSearchTemplate();
                //STOP LOAD
                setIsLoading(false);
              } else {
                BOM.AlertMsg(cnt.SUCCESS, labelConfig.approveCheckerMsg);
                getSearchTemplate();
                //STOP LOAD
                setIsLoading(false);
              }
            });
          } else {
            // Batch submission (2 or more rows)
            selectedRows.map((row) => {
              let body = {
                method: "POST",
                session,
                params,
              };

              const url = `${apiConfig.MakerCheckers}/${row.id}`;

              return BOM.FetchReqAction(body, url, (err, res) => {
                if (err) {
                  BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
                  getSearchTemplate();
                  //STOP LOAD
                  setIsLoading(false);
                } else {
                  BOM.AlertMsg(cnt.SUCCESS, labelConfig.approveCheckerMsg);
                  getSearchTemplate();
                  //STOP LOAD
                  setIsLoading(false);
                }
              });
            });
          }
        } catch (error) {
          console.error(error);
        }
      },

      function () {
        // No button
      }
    );
  }

  function handleOnReject() {
    let action = "Reject ";
    let checkerName = selectedRows.length === 1 ? "Action " : "Actions ";
    setSelectedRowsKeys([]);

    Notiflix.Confirm.show(
      "Are you sure?",
      action + checkerName,
      "Yes",
      "No",

      function () {
        setIsLoading(true);
        const params = {
          command: "reject",
        };

        try {
          if (selectedRows.length === 1) {
            // Single row submission
            let body = {
              method: "POST",
              session,
              params,
            };

            const url = `${apiConfig.MakerCheckers}/${selectedRows[0].id}`;

            BOM.FetchReqAction(body, url, (err, res) => {
              if (err) {
                BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
                getSearchTemplate();
                //STOP LOAD
                setIsLoading(false);
              } else {
                BOM.AlertMsg(cnt.SUCCESS, labelConfig.rejectCheckerMsg);
                getSearchTemplate();
                //STOP LOAD
                setIsLoading(false);
              }
            });
          } else {
            // Batch submission (2 or more rows)
            selectedRows.map((row) => {
              let body = {
                method: "POST",
                session,
                params,
              };

              const url = `${apiConfig.MakerCheckers}/${row.id}`;

              return BOM.FetchReqAction(body, url, (err, res) => {
                if (err) {
                  BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
                  getSearchTemplate();
                  //STOP LOAD
                  setIsLoading(false);
                } else {
                  BOM.AlertMsg(cnt.SUCCESS, labelConfig.rejectCheckerMsg);
                  getSearchTemplate();
                  //STOP LOAD
                  setIsLoading(false);
                }
              });
            });
          }
        } catch (error) {
          console.error(error);
        }
      },

      function () {
        // No button
      }
    );
  }

  const onResetFields = () => {
    useForm.resetFields();
  };

  const onSelectItemAction = (newSelectedRowsKeys, objParam) => {
    setSelectedRows(objParam);
    setSelectedRowsKeys(newSelectedRowsKeys);

    if (newSelectedRowsKeys.length === 1) {
      [
        cnt.RIGHT_DETAIL_BTN,
        cnt.RIGHT_APPROVE_BTN,
        cnt.RIGHT_REJECT_BTN,
        cnt.RIGHT_DELETE_BTN,
      ].map((item) => {
        dispatch({
          type: item,
        });
      });
    } else if (newSelectedRowsKeys.length > 1) {
      dispatch({ type: cnt.CLEAR_RIGHT_BTN });
      [cnt.RIGHT_DELETE_BTN, cnt.RIGHT_APPROVE_BTN, cnt.RIGHT_REJECT_BTN].map(
        (item) => {
          dispatch({
            type: item,
          });
        }
      );
    } else {
      dispatch({ type: cnt.CLEAR_RIGHT_BTN });
    }
  };

  const rowSelection = {
    selectedRowsKeys,
    onChange: onSelectItemAction,
    selections: [Table.SELECTION_ALL, Table.SELECTION_NONE],
  };

  const onSubmit = (formValues) => {
    formValues.makerDateTimeFrom = formValues.makerDateTimeFrom
      ? BOM.DateTime(formValues.makerDateTimeFrom, "iso-date")
      : null;

    formValues.makerDateTimeTo = formValues.makerDateTimeTo
      ? BOM.DateTime(formValues.makerDateTimeTo, "iso-date")
      : null;

    const params = {
      actionName:
        formValues.actionName || formValues.actionName === 0
          ? actionData.find((item) => item.value === formValues.actionName)
              .label
          : null,
      checkerId: formValues.checkerId,
      entityName:
        formValues.entityName || formValues.entityName === 0
          ? entityData.find((item) => item.value === formValues.entityName)
              .label
          : null,
      makerDateTimeFrom: formValues.makerDateTimeFrom,
      makerDateTimeTo: formValues.makerDateTimeTo,
      resourceId: formValues.resourceId,
    };

    const url = `${apiConfig.MakerCheckers}`;
    const body = {
      ...formValues,
      session,
      params,
    };

    setIsLoading(true);
    setShowSearch(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        setIsLoading(false);
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        setIsLoading(false);
        const objList = res;
        let tempArray = [];

        objList.forEach((element) => {
          tempArray.push({
            key: element?.id,
            id: element?.id ? element?.id : "-",
            status: element?.processingResult ? element?.processingResult : "-",
            user: element?.maker ? element?.maker : "-",
            action: element?.actionName ? element?.actionName : "-",
            madeOnDate: element?.madeOnDate
              ? BOM.DateTime(element?.madeOnDate, "only-date")
              : "-",
            entity: element?.entityName ? element?.entityName : "-",
          });
        });

        //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
        // setCheckerInboxList(tempArray.filter((item) => item.disabled === false));
        setCheckerInboxList(tempArray);

        //keep the orginal data to use after gList is modified when change from autorise to disable
        setOriginalList(tempArray);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  return (
    <MainLayout
      isEnableRightSidebar={true}
      onView={handleOnView}
      onDelete={handleOnDelete}
      onApprove={() => handleOnApprove()}
      onReject={() => handleOnReject()}
    >
      <TopContent
        pageTitle={labelConfig.searchCheckerInbox}
        pageItems={staticConfig.searchCheckerInboxBreadcrumbItems}
      />
      <Card
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
      >
        <Spin spinning={isLoading} size="large">
          <Form
            onFinish={onSubmit}
            form={useForm}
            layout="vertical"
            style={{ paddingTop: 20, marginBottom: 50 }}
          >
            <Card
              style={{
                marginBottom: "2%",
                boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
              }}
              bordered
            >
              {/* <Text>RENDER TABLE LIST HERE</Text> */}
              <Button
                type="primary"
                shape="round"
                size="small"
                className="of-primaryBtnColor"
                onClick={onResetFields}
                icon={<ReloadOutlined />}
                loading={isLoading}
              >
                {"Reset"}
              </Button>

              <Row style={{ justifyContent: "space-betwen" }}>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="makerDateTimeFrom"
                    label={<Text>{labelConfig.fromDate}</Text>}
                  >
                    <DatePicker style={{ width: "100%", height: 35 }} />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="makerDateTimeTo"
                    label={<Text>{labelConfig.toDate}</Text>}
                  >
                    <DatePicker style={{ width: "100%", height: 35 }} />
                  </Form.Item>
                </Col>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="actionName"
                    label={<Text>{labelConfig.action}</Text>}
                  >
                    <Select
                      filterOption={(input, option) =>
                        (option?.label?.toLowerCase() ?? "").includes(
                          input?.toLowerCase()
                        )
                      }
                      placeholder={BOM.handlePlaceholderMsg(
                        labelConfig.action,
                        "select"
                      )}
                      options={actionData}
                      showSearch
                      allowClear
                    />
                  </Form.Item>
                </Col>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="entityName"
                    label={<Text>{labelConfig.entity}</Text>}
                  >
                    <Select
                      filterOption={(input, option) =>
                        (option?.label?.toLowerCase() ?? "").includes(
                          input?.toLowerCase()
                        )
                      }
                      placeholder={BOM.handlePlaceholderMsg(
                        labelConfig.entity,
                        "select"
                      )}
                      onChange={(e) => console.log(e)}
                      options={entityData}
                      showSearch
                      allowClear
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="resourceId"
                    label={<Text>{labelConfig.resourceId}</Text>}
                  >
                    <InputNumber
                      placeholder={BOM.handlePlaceholderMsg(
                        labelConfig.resourceId
                      )}
                      style={styles.ofInputFieldNumber}
                    />
                  </Form.Item>
                </Col>
              </Row>

              {showSearch && (
                <>
                  <Row style={{ marginBottom: 20 }}>
                    <DownloadTableButtons
                      downloadData={checkerInboxList}
                      columns={columns}
                      fileName={"Checker Inbox List"}
                    />
                  </Row>
                  <Table
                    rowSelection={{
                      ...rowSelection,
                      onChange: onSelectItemAction,
                    }}
                    columns={columns}
                    dataSource={checkerInboxList}
                    bordered
                    //   title={() => "Customers List"}
                    pagination={{
                      position: "bottomCentre",
                      pageSize: tableCount,
                    }}
                  />
                </>
              )}
            </Card>
            <Form.Item>
              <Row>
                <CustomButton
                  content="Search"
                  style={{
                    width: "10%",
                    marginLeft: "auto",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  htmlType="submit"
                  backgroundColor="#92428B"
                  colorText="white"
                  hoverBackground="#AD4EA7"
                />
              </Row>
            </Form.Item>
          </Form>
        </Spin>
      </Card>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };
export default connect(mapStateToProps, mapDispatchToProps)(SearchCheckerInbox);
